/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Err_Pick_SourceInputs */

const vi_pdc_err_pick_source = /** @type {(inputs: Pdc_Err_Pick_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô nguồn`)
};

/**

* @param {Pdc_Err_Pick_SourceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_err_pick_source = /** @type {((inputs?: Pdc_Err_Pick_SourceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Err_Pick_SourceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_err_pick_source(inputs)
});